import { createFileRoute, redirect } from "@tanstack/react-router";

/** Legacy slug — permanent redirect to the canonical EN URL. */
export const Route = createFileRoute("/contact")({
  beforeLoad: () => {
    throw redirect({ to: "/en/contact", statusCode: 301 });
  },
});
